import { WorkflowConfigType, WorkflowConfigFilter } from '@monorepo/interfaces';

export class LoadWorkflowConfigs {
    static readonly type = '[Workflow] Load Configs';
    constructor(
        public workflowType: WorkflowConfigType,
        public filter?: WorkflowConfigFilter
    ) {}
}

export class LoadSelectedWorkflowConfig {
    static readonly type = '[Workflow] Load Workflow Config';
    constructor(
        public workflowType: WorkflowConfigType,
        public configId: string
    ) {}
}

export class LoadWorkflowConfigById {
    static readonly type = '[Workflow] Load Workflow Config';
    constructor(
        public workflowType: WorkflowConfigType,
        public configId: string
    ) {}
}

export class ClearSelectedWorkflowConfig {
    static readonly type = '[Workflow] Clear Selected Workflow Config';
}
